export default class TestCamera {
    private sss: any;
    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        // super();
        this.sss = uiStage;
        this.onLoad();
    }

    public video = new vf.gui.Video();
    public sprite = new vf.Sprite();
    private stream: void | MediaStream | undefined

    private errorFunc(err: any) {
        console.log(err);
    }

    // 正式启动摄像头
    private async openMedia() {
        //摄像头调用配置
        const front = true;
        // document?.getElementById('flip-button').onclick = function () { front = !front; };
        const mediaOpts: MediaStreamConstraints = {
            audio: true,
            video: { width: 600, height: 600, facingMode: (front ? "user" : "environment"), frameRate: { ideal: 20, max: 30 } }
        };
        this.video.autoplay = true;
        const videoEle = document.createElement('video');
        videoEle.autoplay = true;
        this.stream = await navigator.mediaDevices.getUserMedia(mediaOpts).catch(this.errorFunc);
        if (this.stream) {
            videoEle.srcObject = this.stream;
            this.sprite = vf.Sprite.from(videoEle);
            // this.sprite.scale.set(6);
            this.sss.container.addChild(this.sprite);

            const aaa = new vf.gui.Video();
            aaa.src = this.stream;
            aaa.width = aaa.height = 100;
            aaa.x = 400;
            this.sss.addChild(aaa);

        }
        console.log(this.stream);

    }

    //关闭摄像头
    private closeMedia() {
        if (this.stream) {
            this.stream.getVideoTracks().forEach((track) => {
                track.stop();
            });
        }
    }

    /**
     * 初始化完成后，外部触发调用
     */
    public onLoad() {
        this.sss.addChild(this.video);
        this.openMedia();
    }

    /**
     * 卸载
     */
    public release() {
        // super.release();
        // this.offAll();
        this.closeMedia();
        this.video.release();
    }

    /**
     * 更新显示
     * @param unscaledWidth 
     * @param unscaledHeight 
     */
    protected updateDisplayList(unscaledWidth: number, unscaledHeight: number): void {
        this.video.width = unscaledWidth;
        this.video.height = unscaledHeight;
    }
}